import { Box, Typography } from '@mui/material';
import { Rule } from 'api/ml-service/ml-service.types';
import { useTranslation } from 'react-i18next';
import { useGetItemWordings } from '../custom-rule.hooks';

type CustomRuleSummaryProps = {
  rule: Rule;
};

const CustomRuleSummary = ({ rule }: CustomRuleSummaryProps) => {
  const { t } = useTranslation();
  const { getItemWordings } = useGetItemWordings();

  return (
    <Box display="grid" gridTemplateColumns="1fr 1fr" width="100%">
      <Typography
        component="span"
        data-testid="CustomRuleSummary.Typography.SelectedProducts"
      >
        {getItemWordings(
          [...rule.triggerMenus, ...rule.triggerGroups, ...rule.triggerItems],
          rule.ruleType,
        )}
      </Typography>
      <Typography
        component="span"
        data-testid="CustomRuleSummary.Typography.RecommendedProducts"
      >
        {t(
          'page.menus.recommendations.customRules.savedCustomRules.recommends.label',
        )}{' '}
        {getItemWordings(rule.recommendationItems, rule.ruleType)}
      </Typography>
    </Box>
  );
};

export default CustomRuleSummary;
